import {GitHubAvatar} from '@github-ui/github-avatar'
import {ActionList} from '@primer/react'
import type {AgentInfo} from '../../types/session'
import type {SubAgent} from '../../types/agent'

type AgentListItemsProps = {
  topLevelAgents: AgentInfo[]
  customAgents: SubAgent[]
  selectedAgent: string | null | undefined
  onSelectAgent: (agentName: string | undefined) => void
  onSelectCustomAgent: (agentName: string) => void
  showTopLevelAgents: boolean
}

export function AgentListItems({
  topLevelAgents,
  customAgents,
  selectedAgent,
  onSelectAgent,
  onSelectCustomAgent,
  showTopLevelAgents,
}: AgentListItemsProps) {
  return (
    <>
      {showTopLevelAgents && topLevelAgents.length > 0 && (
        <ActionList.Group selectionVariant="single">
          <ActionList.GroupHeading>Agents</ActionList.GroupHeading>
          {topLevelAgents.map((agent: AgentInfo) => {
            const agentName = agent.display_name || agent.name
            return (
              <ActionList.Item
                key={agent.name}
                disabled={false}
                selected={selectedAgent === agent.name}
                onSelect={() => onSelectAgent(undefined)} // TODO: onSelect should handle selecting top-level agents by passing agent: agent_name (or agent_id) instead of custom_agent: null
              >
                <ActionList.LeadingVisual>
                  <GitHubAvatar src={agent.avatar_url || ''} size={16} square />
                </ActionList.LeadingVisual>
                {agentName}
              </ActionList.Item>
            )
          })}
        </ActionList.Group>
      )}

      {customAgents.length > 0 && (
        <>
          {showTopLevelAgents && topLevelAgents.length > 0 && <ActionList.Divider />}
          <ActionList.Group selectionVariant="single">
            <ActionList.GroupHeading>Custom agents</ActionList.GroupHeading>
            {customAgents.map(agent => {
              const hasConfigError = !!agent.config_error && agent.config_error.length > 0
              return (
                <ActionList.Item
                  key={agent.name}
                  disabled={hasConfigError}
                  inactiveText={hasConfigError ? agent.config_error : undefined}
                  selected={selectedAgent === agent.name}
                  onSelect={() => onSelectCustomAgent(agent.name)}
                >
                  {agent.display_name || agent.name}
                </ActionList.Item>
              )
            })}
          </ActionList.Group>
        </>
      )}
    </>
  )
}

try{ AgentListItems.displayName ||= 'AgentListItems' } catch {}